@if (control && control.value) {
  {{ control.value.length || 0 }}/{{ maxlength }}
}
